export default "__VITE_ASSET__Nqfmx_Ci__"